import { config } from "@/lib/config";

const STORAGE_KEY = "sandbox-agent-token";

/**
 * Local sandboxes only (`yarn sandbox screenshot`, on `*.sandbox.upclaim.localhost`): the AI agent opens the admin with
 * `#sandboxAgentToken=<Auth0 token>`. Kept for the tab, it stands in for the Auth0 session; the API alone decides
 * whether it accepts it (sandbox audience, local sandboxes only). A fragment never reaches the server or its logs.
 */
export function readSandboxAgentToken(): string | null {
  if (!config.SANDBOX_SLUG || !window.location.hostname.endsWith(".sandbox.upclaim.localhost")) {
    return null;
  }
  const fromUrl = new URLSearchParams(window.location.hash.slice(1)).get("sandboxAgentToken");
  if (fromUrl) {
    sessionStorage.setItem(STORAGE_KEY, fromUrl);
    window.history.replaceState(
      window.history.state,
      "",
      `${window.location.pathname}${window.location.search}`,
    );
  }
  return sessionStorage.getItem(STORAGE_KEY);
}

export function clearSandboxAgentToken(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
